import { makeStyles } from '@material-ui/core/styles';

import { fontWeight } from 'theme/typography';

export const useStyles = makeStyles(theme => ({
  sidebarContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    cursor: 'pointer',
  },
  iconContainer: {
    position: 'relative',
    marginTop: theme.spacing(5),
  },
  assetIcon: {
    width: theme.spacing(4),
    height: theme.spacing(6),
  },
  activeIcon: {
    position: 'absolute',
    top: theme.spacing(1.8),
    left: theme.spacing(0.5),
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  firstText: {
    fontFamily: theme.typography.secondaryFontFamily,
    fontSize: theme.typography.h3.fontSize,
    fontWeight: fontWeight.bold,
    color: theme.palette.text.primary,
  },
  secondText: {
    fontFamily: theme.typography.secondaryFontFamily,
    fontSize: theme.typography.h3.fontSize,
    fontWeight: fontWeight.bold,
    color: theme.palette.secondary.main,
  },
  list: {
    marginTop: theme.spacing(5),
  },
  listItem: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.h5.fontSize,
  },
  selectedListItem: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.gray.dark,
    '&:hover': {
      backgroundColor: theme.palette.gray.dark,
    },
    '&:after': {
      position: 'absolute',
      right: 0,
      top: 0,
      height: '100%',
      content: '""',
      backgroundColor: theme.palette.secondary.main,
      width: theme.spacing(0.5),
    },
  },
  listIcon: {
    color: theme.palette.gray.main,
    '& .dashboard_color': {
      fill: theme.palette.gray.main,
    },
    '& .active .dashboard_color': {
      fill: theme.palette.secondary.main,
    },
  },
}));
